<template>
  <div>
      <Widget style="height:'600px'"
          title="<h5 class='d-flex align-items-center pb-1'>
            <span class='circle bg-primary mr-sm' style='font-size: 6px;'></span>
            <span class='fw-normal ml-xs'>NUEVO CUADRO DE CUMPLIMIENTO</span>
          </h4>"
          customHeader>

           <div style="margin:'20px'">
                <b-row>
                    <b-col lg="2" sm="6" xs="12">
                        <vs-input label-placeholder="Nombre CDC" />
                    </b-col>

                    <b-col lg="2" sm="6" xs="12">
                        <vs-input label-placeholder="Default" />
                    </b-col>

                    <b-col lg="2" sm="6" xs="12">
                        <vs-input label-placeholder="Default" />
                    </b-col>

                    <b-col lg="2" sm="6" xs="12">
                        <vs-input label-placeholder="Default" />
                    </b-col>

                    <b-col lg="2" sm="6" xs="12">
                        <vs-input label-placeholder="Default" />
                    </b-col>

                </b-row>
            </div>

</Widget>

    
   
    
  </div>
</template>

<script>
import $ from 'jquery';
/* eslint-disable */
import 'imports-loader?jQuery=jquery,this=>window!flot';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.pie';
/* eslint-enable */
import Widget from '@/components/Widget/Widget';

export default {
  name: 'Dashboard',
  components: { Widget },
  data() {
    return {
      table: [{
        id: 0,
        name: 'Mark Otto',
        email: 'ottoto@wxample.com',
        product: 'ON the Road',
        price: '$25 224.2',
        date: '11 May 2017',
        city: 'Otsego',
        status: 'Sent',
      },
      {
        id: 1,
        name: 'Jacob Thornton',
        email: 'thornton@wxample.com',
        product: 'HP Core i7',
        price: '$1 254.2',
        date: '4 Jun 2017',
        city: 'Fivepointville',
        status: 'Sent',
      },
      {
        id: 2,
        name: 'Larry the Bird',
        email: 'bird@wxample.com',
        product: 'Air Pro',
        price: '$1 570.0',
        date: '27 Aug 2017',
        city: 'Leadville North',
        status: 'Pending',
      },
      {
        id: 3,
        name: 'Joseph May',
        email: 'josephmay@wxample.com',
        product: 'Version Control',
        price: '$5 224.5',
        date: '19 Feb 2018',
        city: 'Seaforth',
        status: 'Declined',
      },
      {
        id: 4,
        name: 'Peter Horadnia',
        email: 'horadnia@wxample.com',
        product: 'Let\'s Dance',
        price: '$43 594.7',
        date: '1 Mar 2018',
        city: 'Hanoverton',
        status: 'Sent',
      }],
    };
  },
  methods: {
  openNewCDC() {
      this.$router.push('/newCDC');
    },

    getRandomData() {
      const arr = [];

      for (let i = 0; i < 25; i += 1) {
        arr.push(Math.random().toFixed(1) * 10);
      }

      return arr;
    },
    getData() {
      const data = [];
      const seriesCount = 3;
      const accessories = ['SMX', 'Direct', 'Networks'];

      for (let i = 0; i < seriesCount; i += 1) {
        data.push({
          label: accessories[i],
          data: Math.floor(Math.random() * 100) + 1,
        });
      }

      return data;
    },
    initChart() {
      $.plot(this.$refs.chartContainer, this.getData(), {
        series: {
          pie: {
            innerRadius: 0.8,
            show: true,
            fill: 0.5,
          },
        },
        colors: ['#ffc247', '#f55d5d', '#9964e3'],
        legend: {
          noColumns: 1,
          container: this.$refs.chartLegend,
          labelBoxBorderColor: '#ffffff',
        },
      });
    },
  },
  mounted() {
    this.initChart();

    window.addEventListener('resize', this.initChart);
  },
};
</script>

<style src="./CDCCreateNew.scss" lang="scss" scoped />
